import { useState, useMemo } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { CheckRow } from "@/components/ExploreFilters";

const SEARCH_MIN = 20;

export function CategoryCheckGrid({ options = [], selected = [], onToggle, testId = "category-check" }) {
  const [query, setQuery] = useState("");
  const showSearch = options.length > SEARCH_MIN;
  const filtered = useMemo(
    () => options.filter((c) => c.toLowerCase().includes(query.trim().toLowerCase())),
    [options, query]
  );
  return (
    <div className="space-y-3" data-testid={testId}>
      {showSearch && (
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input value={query} onChange={(e) => setQuery(e.target.value)} data-testid={`${testId}-search`}
            placeholder="Busca un tipo de taller…" className="pl-9" />
        </div>
      )}
      <div className="grid grid-cols-2 gap-1" data-testid={`${testId}-list`}>
        {filtered.map((c) => (
          <CheckRow key={c} label={c} active={selected.includes(c)} onClick={() => onToggle(c)} testId={`${testId}-${c}`} />
        ))}
      </div>
      {filtered.length === 0 && <p className="text-sm text-muted-foreground py-1">Sin resultados para “{query}”.</p>}
      {selected.length > 0 && (
        <p className="text-xs text-muted-foreground" data-testid={`${testId}-count`}>
          {selected.length} seleccionado{selected.length === 1 ? "" : "s"}
        </p>
      )}
    </div>
  );
}

export function MultiCategorySelect({ options = [], selected = [], onChange }) {
  const all = useMemo(() => [...options, ...selected.filter((s) => !options.includes(s))], [options, selected]);
  const toggle = (c) => onChange(selected.includes(c) ? selected.filter((x) => x !== c) : [...selected, c]);
  return <CategoryCheckGrid options={all} selected={selected} onToggle={toggle} testId="category-check" />;
}
